import { BlogPostContentType } from 'constants/blog';
import { BLOG_CASE_STUDY_EXOMATTER_COVER } from 'constants/images';
import { BlogPost } from 'containers/blog/post/types';

const CaseStudyExomatter: BlogPost = {
  id: 'case-study-exomatter',
  title: 'Case study: ExoMatter',
  subtitle: 'Using AutoML in materials science to predict material properties.',
  previewImage: BLOG_CASE_STUDY_EXOMATTER_COVER,
  date: new Date('17 Dec 2023'),
  content: [
    {
      type: BlogPostContentType.TITLE,
      content: 'Case study: ExoMatter',
    },
    {
      type: BlogPostContentType.SUBTITLE,
      content: 'Using AutoML in materials science to predict material properties.',
    },
    {
      type: BlogPostContentType.POST_INFO,
      content: '17 Dec 2023 · 4 minute read',
    },
    {
      type: BlogPostContentType.MEDIUM_IMAGE,
      content: BLOG_CASE_STUDY_EXOMATTER_COVER,
    },
    {
      type: BlogPostContentType.TEXT,
      content: `This is a case study with Josua, the CEO of ExoMatter, a company that deals with a lot of data in the material science world. We have helped them build a Automated Machine Learning MVP using Google's Vertex AI, to make better use of their data.`,
    },
    {
      type: BlogPostContentType.SUBTITLE,
      content: ``,
    },
    {
      type: BlogPostContentType.SECTION_BREAK,
    },
    {
      type: BlogPostContentType.SUBTITLE,
      content: ``,
    },
    {
      type: BlogPostContentType.TEXT,
      content: <span style={{ fontWeight: 'bold' }}>Can you tell me a bit about ExoMatter?</span>,
    },
    {
      type: BlogPostContentType.TEXT_LEFT_BORDER,
      content: [
        `ExoMatter is a company that deals with materials development and computation, we help companies find the right material for the specific applications, so we replace a lot of trial and error in the lab with data. That's something we do across different industries, so it's not limited to one specific tiype of material, and we can calculate new materials from scratch that didn't exist yet. `,
        <span style={{ fontWeight: 'bold' }}>AI has a key role in growing the business</span>,
        `. One thing is doing simulations and using the data that is there, but those simulations are computationally expensive, so it makes sense to use ML to predict some properties. Also some of those properties are not accessible in any other way, so we use ML to fill in the gaps. What we have been doing so far is that we've done some experiments building our own ML models; we have either used models that already exist, but we've also built our own models, and it took quite some time, to build them, structuring the data, and finding out what algorithm to use and what features are important. That's why we thought AutoML could have been a good solution.`,
      ],
    },
    {
      type: BlogPostContentType.SUBTITLE,
      content: ``,
    },
    {
      type: BlogPostContentType.TEXT,
      content: (
        <span style={{ fontWeight: 'bold' }}>
          How did we start working and what was the process for choosing a vendor for the ML MVP?
        </span>
      ),
    },
    {
      type: BlogPostContentType.TEXT_LEFT_BORDER,
      content: [
        `We knew each other before, we knew what your capabilities are. `,
        <span style={{ fontWeight: 'bold' }}>
          I had the feeling that you could get things done quickly
        </span>,
        `. We had to get quotations from other agencies for this project, but in the end yours was the most convincing. `,
        <span style={{ fontWeight: 'bold' }}>You already had some ideas on what do to</span>,
        `, so that was quite an easy decision.`,
      ],
    },
    {
      type: BlogPostContentType.SUBTITLE,
      content: ``,
    },
    {
      type: BlogPostContentType.TEXT,
      content: (
        <span style={{ fontWeight: 'bold' }}>
          How would you describe the collaboration in a remote setting?
        </span>
      ),
    },
    {
      type: BlogPostContentType.TEXT_LEFT_BORDER,
      content: [
        `I would say it was quite efficient. We first had to get a standing on the project matter, as chemistry is not something someone deals with everyday, so we had to spend some time in the beginning, and then we did regular calls when something was ready. I think it was quite easy to collaborate, especially also given that I didn't have too much time. `,
        <span style={{ fontWeight: 'bold' }}>
          I trusted you to give a good result, and that&apos;s what happened
        </span>,
        `. It was good.`,
      ],
    },
    {
      type: BlogPostContentType.SUBTITLE,
      content: ``,
    },
    {
      type: BlogPostContentType.TEXT,
      content: (
        <span style={{ fontWeight: 'bold' }}>What is your feedback on our communication?</span>
      ),
    },
    {
      type: BlogPostContentType.TEXT_LEFT_BORDER,
      content: [
        ``,
        <span style={{ fontWeight: 'bold' }}>I think it was great</span>,
        `. Also, the documentation you did was good, so not really much to improve on that.`,
      ],
    },
    {
      type: BlogPostContentType.TEXT,
      content: ``,
    },
    {
      type: BlogPostContentType.TEXT,
      content: (
        <span style={{ fontWeight: 'bold' }}>
          In the first few weeks we got the MVP working. What do you think about the tradeoff
          between cost, speed and quality of AutoML models?
        </span>
      ),
    },
    {
      type: BlogPostContentType.TEXT_LEFT_BORDER,
      content: [
        `That's great, is was exactly what we were hoping to see. It was a pilot project, and the goal was to see if it would work or not. It could have been that it didn't work with the data we were using. The models we built before took 3/4 months to build (for one model). `,
        <span style={{ fontWeight: 'bold' }}>
          Now we have this AutoML pipeline where we don&apos;t have to do much, it trains overnight
        </span>,
        `, that we tested on 2 datasets, and `,
        <span style={{ fontWeight: 'bold' }}>the results were at least as good</span>,
        ` as previous results. I'm quite happy with those results.`,
      ],
    },
    {
      type: BlogPostContentType.SUBTITLE,
      content: ``,
    },
    {
      type: BlogPostContentType.TEXT,
      content: (
        <span style={{ fontWeight: 'bold' }}>
          In the first few weeks we got the MVP working. What do you think about the tradeoff
          between cost, speed and quality of AutoML models?
        </span>
      ),
    },
    {
      type: BlogPostContentType.TEXT_LEFT_BORDER,
      content: [
        ``,
        <span style={{ fontWeight: 'bold' }}>I could not have wished for anything better</span>,
        `, because it was really within the budget that we originally planned. In my head I always had some buffer, because we had more budget than we contracted, just to make sure in case something goes wrong we can still do it, but we did not need that kind of buffer. So in the end we used it to explore some more options to improve the data quality, which we didn't plan originally. `,
        <span style={{ fontWeight: 'bold' }}>I&apos;m quite happy with that</span>,
        `.`,
      ],
    },
    {
      type: BlogPostContentType.SUBTITLE,
      content: ``,
    },
    {
      type: BlogPostContentType.TEXT,
      content: (
        <span style={{ fontWeight: 'bold' }}>
          Would you recommend our services for other similar companies and what would be the reason?
        </span>
      ),
    },
    {
      type: BlogPostContentType.TEXT_LEFT_BORDER,
      content: [
        <span style={{ fontWeight: 'bold' }}>Yes, definitely</span>,
        `. I would recommend you if someone needs short term support in AI projects. We've not gone beyond this AI use case, but `,
        <span style={{ fontWeight: 'bold' }}>I&apos;m sure you can handle other things</span>,
        `.`,
      ],
    },
    {
      type: BlogPostContentType.SUBTITLE,
      content: ``,
    },

    {
      type: BlogPostContentType.SUBTITLE,
    },
    {
      type: BlogPostContentType.CONTACT_ME_FORM,
    },
  ],
};

export default CaseStudyExomatter;
